"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.font = void 0;
exports.font = {
    size: {
        xxxs: '0.75rem',
        xxs: '0.875rem',
        xs: '1rem',
        sm: '1.25rem',
        md: '1.5rem',
        lg: '2rem',
        xl: '2.5rem',
        xxl: '3rem',
        xxxl: '4rem',
        display: '5rem',
        giant: '6rem'
    },
    family: {
        base: 'Open Sans, "Helvetica Neue", Arial, sans-serif'
    },
    weight: {
        regular: 400,
        semibold: 600,
        bold: 700
    }
};
